// extracted by mini-css-extract-plugin
module.exports = {"root":"Community-root-56fec3df7547e8a9804adb7fefb54834"};